'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.immutableSettingsSelector = exports.settingsSelector = exports.settingsValueSelector = undefined;

var _immutable = require('immutable');

var _reselect = require('reselect');

var settingsValueSelector = exports.settingsValueSelector = function settingsValueSelector(state, settingsKey) {
  var settings = state.settings;


  return settings[settingsKey] ? Boolean(settings[settingsKey].value) : false;
};

var settingsSelector = exports.settingsSelector = function settingsSelector(state) {
  return state.settings;
};

var immutableSettingsSelector = exports.immutableSettingsSelector = (0, _reselect.createSelector)(settingsSelector, function (settings) {
  return (0, _immutable.fromJS)(settings);
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/SettingsSelectors.js
// module id = 728
// module chunks = 3 4